/** Numbers as the app report writes them. */
export const n = (v: number) => v.toLocaleString();
export const pct = (v: number, of: number) => (of ? `${((v / of) * 100).toFixed(1)}%` : '—');
